import React from 'react';
import { RemediationsList } from '../Components/RemediationsList';
import { ICloudEntityData } from 'common/module_interface/assets/ICloudEntity';

const TopRemediationsWidget: React.FC<{ entity: ICloudEntityData }> = ({ entity }) => {
    return <RemediationsList entity={entity}></RemediationsList>;
};

export default TopRemediationsWidget;
